<template>
  <section class="section mobile_div section_bg custom_page_v2 first_page section_no_background">

  <div class="container d-flex justify-content-center  " v-if="is_load && post.category_post.project_id==0">
      <div class="section_header no_margin back_div_element container mobile_div">

        <router-link   tag="a" class="btn" :to="{'name':'category_blog','params':{'alias':post.category_post.alias}}"  ><i class="fa fa-backward"></i> Назад</router-link>

      </div>
  </div>


    <div class=" ">


      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="container mobile_div" v-if="is_load" >
      <div class="second_section">
        <h2 class="text-center">Редактировать запись</h2>
        <div class="container-fluid">
          <div class="form-group row">
            <div class="col-md-3 col-12">
              <p class="mt-2">Категория</p>
            </div>
            <div class="col-md-9 col-12">
            <select id="exampleCategoryitem" v-model="post.category" required
                class="form-control">

              <option  v-for="category in categorys" :value="category.last_id"
                  :key="category.last_id">{{
                  category.title
                }}
              </option>



            </select>
            </div>

          </div>
          <div class="form-group " v-if="post.category_post && post.category_post.project_id>0">
            Пост закреплен?
            <input type="checkbox" v-model="post.is_pinned" value="1"/>
          </div>

          <editorjsinput :blocks_json="post.content.blocks" ref="editorjs" ></editorjsinput>


          <div class="alert alert-danger" v-if="iserror==true">
            <p>{{ error_message }}</p>
          </div>
          <base-button  @click="onSaveWork" >Сохранить запись</base-button>
        </div></div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import Editorjsinput from "../../models/Editorjsinput";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "EditPost",
  data() {

    var app = this;

    return {
      'work_id':null,

      'post':null,
      'example_blocks':[
        {
          "type": "header",
          "data": {
            "text": "Название записи",
            "level": 2
          }
        },

        {
          "type": "paragraph",
          "data": {
            "text": "Здесь какое то описание",
          }
        },

      ],
      'is_load':false,
      'categorys':[],
      'iserror':false,
      'error_message':'',




    }
  },
  mounted: function () {
    var app = this;

    let id = app.$route.params.id;


    Api.loadPost(id,function(post){
    app.post=post;

    if(post.category_post.project_id>0){
      var new_categorys=[];
      new_categorys.push(post.category_post);
     app.categorys=new_categorys;
      app.is_load=true;
    }else {
      Api.loadBlogFormCategorys(function(data){


        app.categorys=data;
        app.is_load=true;
      })
    }

    });





  },components: {
    'editorjsinput': Editorjsinput,
    LoadingBlock,
  },methods:{

    onSaveWork(){
      var app=this;
      app.$refs.editorjs.save(function(editor_js_data){

        var newPost=app.post;
        app.post.content.blocks=editor_js_data.blocks;

        newPost['json']=editor_js_data;
        app.is_load=false;

        Api.createPost(newPost, function (result) {
          app.is_load=true;
          if (result.iserror == false) {
            app.iserror = false;
            app.$router.push({name: 'post',params: {id: result.post_id, "alias":result.alias}});

           // document.location = "/post/"+result.alias+"/" + result.post_id+"/";
          } else {
            app.iserror = true;
            app.error_message = result.error_message;
          }
        });



      });
    },


  },
}
</script>

<style scoped>

</style>